import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { stats } from '../../utils/data';

export default function StatsSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-16 bg-hero-gradient relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-accent rounded-full blur-2xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div
          ref={ref}
          className={`grid grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {stats.map(({ value, label }, i) => (
            <div
              key={label}
              className="text-center"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="font-display text-4xl sm:text-5xl font-bold text-white mb-2">
                {value}
              </div>
              <div className="text-blue-200 text-sm font-medium tracking-wide">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
